/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

export const normalizeSectorOptions = (options = []) => {
  return options
    .map(option => String(option || '').trim())
    .filter(Boolean)
    .filter((option, index, arr) => arr.indexOf(option) === index)
    .sort((a, b) => a.localeCompare(b));
};
